<template>
  <lazy-dom>
    <div class="policy-form">
      <el-form
        ref="form"
        :rules="rules"
        :disabled="showBuyable"
        :model="formData">
        <div
          v-if="isCancel"
          class="box">
          <h3></h3>
          <div
            class="flex-sb">
            <div class="form-item form-half">
              <span>Cancellation Effective Date</span>
              <el-form-item
                ref="pcy_expry_dt"
                :prop="checkRefer===1?'':'pcy_expry_dt'">
                <v-date-picker
                  v-model="formData.pcy_expry_dt"
                />
              </el-form-item>

            </div>
          </div>
        </div>
        <div class="box policy-content">
          <h3>Policy Details</h3>
          <div
            v-if="!isCancel"
            class="form-item form-half">
            <span>Expected Effective Date</span>
            <el-form-item
              ref="policy_detail.pcy_cmnt_dt"
              :rules="rules.timeRequired"
              prop="policy_detail.pcy_cmnt_dt"
            >
              <v-date-picker
                v-model="formData.policy_detail.pcy_cmnt_dt"
              />
            </el-form-item>

          </div>
          <div class="form-item form-half">
            <span>Is your Insured Address / Place of Employment same as Correspondence Address?</span>
            <el-form-item
              ref="policy_detail.same_as_corr_addr_ind"
              :rules="rules.smeSelect"
              prop="policy_detail.same_as_corr_addr_ind">
              <v-radio-group
                v-model="formData.policy_detail.same_as_corr_addr_ind"
                :block="true"
                :list="smeYesNoOptions"
                :radio-name="'policy_detail.same_as_corr_addr_ind'"
                @change="handleChange" />
            </el-form-item>
          </div>
          <div
            v-if="policy_detail.same_as_corr_addr_ind==2"
            class="form-half">
            <span class="title">Insured Address / Place of Employment</span>
            <address-form
              ref="address-form"
              :formType="1"
              :formDataLock="formDataLock"
              :form="formData.policy_detail.insured_address"
              :disabled="isCancel||showBuyable"
              :not-valid="checkRefer===1?true:false"
              @getFormData="getSubimitForm" />
          </div>

          <div class="form-item">
            <span>Is it a newly established company?</span>
            <el-form-item
              ref="policy_detail.newly_com_ind"
              :rules="rules.smeSelect"
              prop="policy_detail.newly_com_ind">
              <v-radio-group
                v-model="formData.policy_detail.newly_com_ind"
                :block="true"
                :list="smeYesNoOptions" />
            </el-form-item>
          </div>
          <div
            v-if="showNature"
            class="form-item form-half">
            <span>Business Nature</span>
            <el-form-item
              ref="policy_detail.bus_nature"
              prop="policy_detail.bus_nature">
              <v-select
                v-model="formData.policy_detail.bus_nature"
                :disabled="true"
                :list="smeOptions.business_nature" />
            </el-form-item>
          </div>
          <div
            v-if="showHour"
            class="form-item form-half">
            <span>Business Hour</span>
            <el-form-item
              :rules="rules.select_time"
              prop="select_time"
            >
              <div class="flex-sb-center">
                <div class="form-half select-time">
                  <el-time-select
                    v-model="startTime"
                    placeholder="Select"
                    :picker-options="{
                      start: '00:00',
                      step: '00:30',
                      end: '23:30',
                    }">
                  </el-time-select>
                </div>
                <div class="form-half select-time">
                  <!--                    minTime: startTime-->
                  <el-time-select
                    v-model="endTime"
                    placeholder="Select"
                    :picker-options="{
                      start: '00:00',
                      step: '00:30',
                      end: '23:30',
                    }">
                  </el-time-select>
                </div>
              </div>


            </el-form-item>
          </div>
          <div
            v-if="showClasses"
            class="form-item form-half">
            <span>Class Session</span>
            <el-form-item
              ref="policy_detail.classes_id"
              :rules="rules.smeSelect"
              prop="policy_detail.classes_id">
              <v-select
                v-model="formData.policy_detail.classes_id"
                :block="true"
                :list="smeOptions.classes" />
            </el-form-item>
          </div>
          <div
            v-if="showClasses"
            class="form-item form-half">
            <span>No. of participants per class?</span>
            <el-form-item
              ref="policy_detail.bus_nature"
              :rules="rules.select"
              prop="policy_detail.bus_nature">
              <v-select
                v-model="formData.policy_detail.no_per_class"
                :list="smeOptions.number_per_class"
              />
            </el-form-item>
          </div>
        </div>

        <div class="box">
          <h3>Policyholder Details</h3>
          <policy-holder
            ref="policy-holder"
            :form="policyholder_detail"
            :form-data-lock="formDataLock"
            :disabled="showBuyable"
            @getFormData="getSubimitForm"></policy-holder>
        </div>

        <div class="box ">
          <h3>Other Information</h3>
          <div
            v-if="showStock"
            class="form-item form-half">
            <span>What kind of stock?</span>
            <el-form-item
              :rules="rules.select"
              prop="other_info.kinds_of_stocks">
              <v-checkbox-group
                v-model="formData.other_info.kinds_of_stocks"
                :block="true"
                :list="stockList" />
            </el-form-item>
          </div>
          <div
            v-if="showStock"
            class="form-item form-half">
            <span>Max. value per consumer packing</span>
            <el-form-item
              ref="other_info.max_val_per_stocks"
              prop="other_info.max_val_per_stocks"
            >
              <v-input
                v-model="formData.other_info.max_val_per_stocks"
                :int="true"
                maxlength="5"
                :key-number="true"/>
            </el-form-item>
          </div>
          <div
            v-if="showHigh"
            class="form-item form-half">
            <span>Is there any beauty device(s) valued over HK$100,000?</span>
            <el-form-item
              ref="other_info.high_value_dev_ind"
              prop="other_info.high_value_dev_ind"
              :rules="rules.smeSelect"
            >
              <v-radio-group
                v-model="formData.other_info.high_value_dev_ind"
                :block="true"
                :list="smeYesNoOptions"
                :radio-name="'other_info.high_value_dev_ind'"
                @change="handleChange"
              />
            </el-form-item>
          </div>
          <div
            v-if="showHigh&&other_info.high_value_dev_ind==1"
            class="form-item form-half">
            <span>Total sum insured of the beauty device(s) (over HK$100,000 per unit/set)</span>
            <el-form-item
              ref="other_info.high_value_dev_isrd"
              prop="other_info.high_value_dev_isrd"
            >
              <v-input
                v-model="formData.other_info.high_value_dev_isrd"
                :int="true"
                :max="30000000"
                :key-number="true"/>
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Is a burglary alarm installed in your premises?</span>
            <el-form-item
              ref="other_info.alarm_install_ind"
              :rules="rules.smeSelect"
              prop="other_info.alarm_install_ind">
              <v-radio-group
                v-model="formData.other_info.alarm_install_ind"
                :block="true"
                :radio-name="'other_info.alarm_install_ind'"
                :list="smeYesNoOptions"
                @change="handleChange" />
            </el-form-item>
          </div>
          <div
            v-if="other_info.alarm_install_ind!=2"
            class="form-item form-half">
            <span>Please provide details of the burglary alarm system installed in your premises.</span>
            <el-form-item
              prop="other_info.alarm_detail">
              <v-input
                v-model="formData.other_info.alarm_detail"
                type="textarea"
                :rows="4"
              />
            </el-form-item>
          </div>
          <div
            v-if="showFire"
            class="form-item form-half">
            <span>Any sprinkler or fire extinguisher system?</span>
            <el-form-item
              :rules="rules.smeSelect"
              prop="other_info.fire_sprinkler_ind">
              <v-radio-group
                v-model="formData.other_info.fire_sprinkler_ind"
                :block="true"
                :list="smeYesNoOptions" />
            </el-form-item>
          </div>
          <h3 class="title-span bold block form-half">Does any of the work carry out by the employers involve:</h3>
          <div class="form-item form-half">
            <span>Work in/on or visiting construction sites, ships, shipyards, chemical works, off-shore structures, oil or gas refineries?</span>
            <el-form-item
              :rules="rules.smeSelect"
              prop="other_info.wk_in_danger_pos_ind">
              <v-radio-group
                v-model="formData.other_info.wk_in_danger_pos_ind"
                :block="true"
                :list="smeYesNoOptions" />
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Work over 30 feet or work underground? </span>
            <el-form-item
              :rules="rules.smeSelect"
              prop="other_info.wk_in_high_ind">
              <v-radio-group
                v-model="formData.other_info.wk_in_high_ind"
                :block="true"
                :list="smeYesNoOptions" />
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Work outside Hong Kong?</span>
            <el-form-item
              :rules="rules.smeSelect"
              prop="other_info.wk_outside_hk_ind">
              <v-radio-group
                v-model="formData.other_info.wk_outside_hk_ind"
                :block="true"
                :list="smeYesNoOptions" />
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Use, handle, store or transport any hazardous substances such as toxic chemicals, explosive substances, gases, asbestos, radioactive substances? </span>
            <el-form-item
              :rules="rules.smeSelect"
              prop="other_info.use_hazardous_ind">
              <v-radio-group
                v-model="formData.other_info.use_hazardous_ind"
                :block="true"
                :list="smeYesNoOptions" />
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Do you plan to increase the number of the employees substantially or add different occupations in a short period of time?</span>
            <el-form-item
              ref="other_info.incr_employee_ind"
              :rules="rules.smeSelect"
              prop="other_info.incr_employee_ind">
              <v-radio-group
                v-model="formData.other_info.incr_employee_ind"
                :block="true"
                :list="smeYesNoOptions" />
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Has your company or employees had any previous loss, damage or injury covered by this Plan in the past 3 years? </span>
            <el-form-item
              :rules="rules.smeSelect"
              prop="other_info.prev_loss_ind">
              <v-radio-group
                v-model="formData.other_info.prev_loss_ind"
                :block="true"
                :list="smeYesNoOptions" />
            </el-form-item>
          </div>
        </div>
        <div class="travel-box box">
          <h2>Upload Document</h2>
          <div >
            <div class="form-item form-half-6">
              <span>Business Registration Certificate</span>
              <el-form-item
                ref="upload_document.br_files"
                :rules="rules.upload"
                prop="upload_document.br_files">
                <v-upload
                  :card="true"
                  :fileData="br_files_type_pic"
                  :otherData="{
                    type:'br_files',
                    target: 'br_files_type_pic',
                    idKey: 'br_files_path_id',
                    nameKey: 'br_files_type_pic_path'
                  }"
                  @delete="handlerDeleteBrFiles"
                  @uploadSuccess="handlerUploadSuccess"
                />
              </el-form-item>
            </div>
            <div class="form-item form-half-6">
              <span>The latest 3 months of MPF Contribution Record</span>
              <span class="font-12 gray mg-b-10">Max. 10 files and each file size no more than 10MB</span>
              <el-form-item
                ref="upload_document.mpf_files"
                :rules="formData.policy_detail.newly_com_ind==1?[]:rules.upload"
                prop="upload_document.mpf_files">

                <file-container
                  v-for="(item, index) in mpf_files"
                  :key="index"
                  :edit="true"
                  :fileData="item"
                  :otherData="{
                    index,
                    target: 'mpf_files'
                  }"
                  titleName= "MPF Documents"
                  @delete="handlerDeleteFile"
                  @uploadSuccess="handlerUploadSuccess"
                />
                <v-upload
                  :otherData="{
                    type: 'other',
                    target: 'mpf_files'
                  }"
                  @uploadSuccess="handlerUploadSuccess" />
              </el-form-item>
            </div>
            <div
              class="form-item form-half-6">
              <span>Renewal Notice / Existing Policy</span>
              <span class="font-12 gray mg-b-10">Max. 10 files and each file size no more than 10MB</span>
              <!--              ref="upload_document.renewal_files"-->
              <!--              prop="upload_document.renewal_files"-->
              <el-form-item
              >
                <file-container
                  v-for="(item, index) in renewal_files"
                  :key="index"
                  :edit="true"
                  :fileData="item"
                  :otherData="{
                    index,
                    target: 'renewal_files'
                  }"
                  titleName= "Renewal Documents"
                  @delete="handlerDeleteFile"
                  @uploadSuccess="handlerUploadSuccess"
                />
                <v-upload
                  :otherData="{
                    type: 'other',
                    target: 'renewal_files'
                  }"
                  @uploadSuccess="handlerUploadSuccess" />
              </el-form-item>
            </div>
            <div
              v-if="isNeed"
              class="form-item form-half-6">
              <span>List of  machines / devices to be insured (valued over HKD100,000 per item/set)</span>
              <el-form-item
                ref="upload_document.device_files"
                :rules="rules.document_upload"
                prop="upload_document.device_files">
                <file-container
                  v-for="(item, index) in device_files"
                  :key="index"
                  :edit="true"
                  :fileData="item"
                  :otherData="{
                    index,
                    target: 'device_files'
                  }"
                  titleName= "Device Documents"
                  @delete="handlerDeleteFile"
                  @uploadSuccess="handlerUploadSuccess"
                />
                <v-upload
                  :otherData="{
                    type: 'other',
                    target: 'device_files'
                  }"
                  @uploadSuccess="handlerUploadSuccess" />
              </el-form-item>
            </div>
          </div>
        </div>

      </el-form>
    </div>
  </lazy-dom>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
import AddressForm from '@/views/components/address-form'
import PolicyHolder from './policy-holder-form'
import {mapState} from 'vuex'
import {smeClassId} from '@/utils/smePath'

export default {
  name: 'smeForm',
  components: {
    PolicyHolder,
    AddressForm
  },
  mixins: [MixinOptions, MixinFormat, MixinRules],
  props: {
    form: {
      type: Object,
      default: ()=>({})
    },
    editType:{
      type:Number,
      default:0
    },
    checkRefer:{
      type:Number,
      default:0
    },
    isCancel: {
      type: Boolean,
      default: false
    },
    isEndorsement: {
      type: Boolean,
      default: false
    },
    showBuyable: {
      type: Boolean,
      default: false
    },
    isRefer: {
      type: Boolean,//refer case 显示insured item 全部选项
      default: false
    },
    formDataLock: {
      type: Number,
      default: 0
    },
  },
  data() {
    const checkSelect = (rule, value, callback) => {
      const field_arr = rule.field.split('.')||[]
      const target = field_arr[0]
      const val = field_arr[1]
      let selectVal = this.formData[target][val]
      if(selectVal<=0) {
        callback( new Error(this.$t('placeholder.select') ) )
      }
      callback()
    }
    const checkDateSelect = (rule, value, callback) => {
      let {pcy_cmnt_dt} = this.formData.policy_detail||{}
      if(!pcy_cmnt_dt) {
        callback( new Error(this.$t('placeholder.select') ) )
      }
      callback()
    }
    const needUpload = (rule, value, callback) => {
      //"beauty , Hair Salon, Medical Center
      let need = [84,86,88].includes(this.classId)
      let {device_files=[]} = this.formData.upload_document
      if(device_files.length<=0&&need) {
        callback( new Error(this.$t('placeholder.upload') ) )
      }
      callback()
    }
    const checkSelectTime = (rule, value, callback) => {
      let startTime = this.startTime
      let endTime = this.endTime
      if(!startTime||!endTime) {
        callback( new Error(this.$t('placeholder.select') ) )
      }
      callback()
    }
    return {
      oldFormDataLock: -1,
      content_detail:{},
      policy_detail:{
        same_as_corr_addr_ind:0
      },
      other_info:{
        kinds_of_stocks:[],
        max_val_per_stocks:2,
        fire_sprinkler_ind:2,
        alarm_install_ind:2,
        wk_in_danger_pos_ind:2,
        wk_in_high_ind:2,
        wk_outside_hk_ind:2,
        use_hazardous_ind:2,
        prev_loss_ind:2,
        high_value_dev_isrd:'',
        high_value_dev_ind:null,
        alarm_detail:'',
        incr_employee_ind:null
      },
      formData: {
        less_verify_save: 0, // 是否僅保存部分資料（1：部分保存；0：全部保存   --标记是create 还是 edit
        policy_detail:{
          pcy_cmnt_dt:'',
          bus_hour:'',
          newly_com_ind:'',
          same_as_corr_addr_ind:'',
          insured_address:{
            addr_room: '',
            addr_floor: '',
            addr_block: '',
            addr_building: '',
            addr_street: '',
            addr_district: '',
            addr_area: '',
            addr_region: '',
            classes_id:''
          },
          no_per_class:'',
        },
        policyholder_detail:{
          isrd_com_nm:'',
          id_no:'',
          phone_no:'',
          email:'',
          corr_address:{
            addr_room: '',
            addr_floor: '',
            addr_block: '',
            addr_building: '',
            addr_street: '',
            addr_district: '',
            addr_area: '',
            addr_region: '',
          },
          contact_nm:'',
          contact_phone:''
        },
        other_info:{
          kinds_of_stocks:[],
          max_val_per_stocks:2,
          fire_sprinkler_ind:2,
          alarm_install_ind:2,
          wk_in_danger_pos_ind:2,
          wk_in_high_ind:2,
          wk_outside_hk_ind:2,
          use_hazardous_ind:2,
          prev_loss_ind:2,
          high_value_dev_isrd:'',
          high_value_dev_ind:null,
          alarm_detail:'',
          incr_employee_ind:null
        },
        upload_document:{
          br_files:[],
          mpf_files:[],
          renewal_files:[],
          device_files:[],
        },
        br_files_path_id: '',
        br_files_type_pic_path: ''
      },
      br_files_type_pic:{},
      mpf_files:[],
      device_files:[],
      renewal_files:[],
      startTime: '',
      endTime: '',
      subForm: {
        'address-form': false,
        'policy-holder': false,
      },
      rules: {
        timeRequired: [
          {validator: checkDateSelect,message: this.$t('placeholder.select'), trigger: ['blur','change'] },
        ],
        smeSelect: [
          {validator: checkSelect,message: this.$t('placeholder.select'), trigger: ['blur','change',] },
        ],
        select_time: [
          {validator: checkSelectTime,message: this.$t('placeholder.select'), trigger: ['change', 'blur'] },
        ],
        document_upload:[
          {validator: needUpload,message: this.$t('placeholder.upload'), trigger: ['change', 'blur'] },
        ]
      },
    }
  },
  computed: {
    ...mapState('smeQuote', ['smeQuickForm']),
    isNeed(){
      let need = [84,86,88].includes(this.classId)
      let {other_info} = this.formData||{}
      let {high_value_dev_ind} = other_info||{}
      return need&&high_value_dev_ind==1
    },
    type(){
      let {type} = this.$route.params
      return type
    },
    disableNature(){
      return [82,83].includes(this.classId)
    },
    orderId(){
      let {order_id} = this.$route.query||{}
      return order_id
    },
    productId(){
      let {product_id} = this.$route.query||{}
      return product_id||this.form.class_id
    },
    smeOptions(){
      return this[`smeOptions${this.classId}`]||{}
    },
    stockList(){
      let {bus_nature} = this.formData.policy_detail||{}
      if(this.classId==83){
        let {kind_of_stock={}} = this.smeOptions
        return kind_of_stock[`bus_nature_${bus_nature}`]
      }
      return this.smeOptions.kind_of_stock
    },
    classId(){
      return this.type?smeClassId[this.type]:this.form.class_id
    },
    showHour(){
      return [81,83,84,86,85,88].includes(this.classId)
    },
    showNature(){
      return [81,82,83,84,85,88].includes(this.classId)
    },
    showClasses(){
      return [85].includes(this.classId)
    },
    showStock(){
      return [81,83,84,86,85,88].includes(this.classId)&&this.isShowStock
    },
    isShowStock(){
      let {stocks_ind} = this.content_detail||{}
      return stocks_ind==1
    },
    showFire(){
      return [81,83,84,86,85,88].includes(this.classId)
    },
    showHigh(){
      return [84,86,88].includes(this.classId)
    },
    policyholder_detail(){
      let {policyholder_detail={}} =this.form||{}
      return policyholder_detail||{}
    },
    isRules(){
      return this.checkRefer ===2
    },
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    form: {
      immediate: true,
      deep:true,
      handler(val) {
        if(this.formDataLock !== this.oldFormDataLock) {
          // 觸發更新就賦值，避免二次更新
          this.oldFormDataLock = this.formDataLock
          if (val) {
            this.formData = val || {}
            let {policy_detail,content_detail,other_info} = val || {}
            this.content_detail = content_detail||{}
            this.policy_detail = policy_detail
            this.other_info = other_info
            let {bus_hour,insured_address} = policy_detail || {}
            if(JSON.stringify(insured_address)=='[]')
            {
              this.formData.insured_address = {}
            }
            if (bus_hour) {
              let hour = bus_hour.split('-')
              this.startTime = hour[0]
              this.endTime = hour[1]
            }
            let {upload_document = {}} = val
            let {br_files = [],mpf_files=[],device_files=[],renewal_files=[]} = upload_document||{}
            this.br_files_type_pic = br_files[0]
            this.mpf_files = mpf_files
            this.renewal_files = renewal_files
            this.device_files = device_files
            this.class_id = val.class_id
          }
        }
      }
    },
    disableNature:{
      immediate:true,
      handler(val){
        if(val){
          let {basic_info} = this.smeQuickForm
          this.formData.policy_detail.bus_nature =this.formData.policy_detail.bus_nature||basic_info.bus_nature
        }
      }
    }
  },
  created() {
    this.handlerInit()
  },
  methods: {
    handlerInit(){
      let val = this.form
      if (val) {
        this.formData = val || {}
        let {policy_detail} = val || {}
        let {bus_hour} = policy_detail || {}
        if (bus_hour) {
          let hour = bus_hour.split('-')
          this.startTime = hour[0]
          this.endTime = hour[1]
        }
        let {upload_document = {}} = val
        let {br_files = [],mpf_files=[],device_files=[],renewal_files=[]} = upload_document||{}
        this.br_files_type_pic = br_files[0]
        this.mpf_files = mpf_files
        this.renewal_files = renewal_files
        this.device_files = device_files
        this.class_id = val.class_id
      }
    },
    handleChange(val,name) {
      this[name] = val
    },
    checkDisabled(field) {
      const { disable_filed = [] } = this.form||{}
      return disable_filed.includes(field)&&this.form[field]!=''
    },
    lessSubmitForm(otherData = {}){
      this.otherData = otherData
      let {policy_detail={}} = this.formData
      let {same_as_corr_addr_ind} = policy_detail
      let subForm = this.subForm
      if(!same_as_corr_addr_ind||same_as_corr_addr_ind==1){
        delete subForm['address-form']
      }
      Object.keys(subForm).some(key => {
        this.subForm[key] = false
        this.$refs[key].submitFormNoVaild(key)
      })
      const result = {
        ...this.formData,
      }
      result.policy_detail.bus_hour =`${this.startTime}-${this.endTime}`

      this.$emit('getFormData', result, otherData)

    },
    submitForm(otherData = {}) {
      let {policy_detail={}} = this.formData
      let {same_as_corr_addr_ind} = policy_detail
      let subForm = this.subForm
      if(!same_as_corr_addr_ind||same_as_corr_addr_ind==1){
        delete subForm['address-form']
      }
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          this.otherData = otherData
          Object.keys(subForm).some(key => {
            subForm[key] = false
            this.$refs[key].submitForm(key)
          })
          if(Object.values(this.subForm).some(item => item === false)) {
            return
          }
          const result = {
            ...this.formData,
          }
          result.policy_detail.bus_hour =`${this.startTime}-${this.endTime}`
          this.$emit('getFormData', result, otherData)
        }
        else {
          this.scrollToValidDom(rules)
        }
      })

    },
    getSubimitForm(form, data) {
      // debugger
      this.subForm[form] = true
      if(form == 'address-form') {
        this.formData.policy_detail.insured_address = {...this.formData.policy_detail.insured_address,...data}
      }
      else {
        this.formData.policyholder_detail =  Object.assign(this.formData.policyholder_detail, data)
      }
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { idKey, nameKey, target, index = '', type } = otherData
      const { id, path,thumb_url,url } = data
      if(target == 'br_files_type_pic') {
        // this.$set(this.formData, idKey, id)
        // this.$set(this.formData, nameKey, path)
        this.$set(this.formData.upload_document,type,[{id:id}])
        this.br_files_type_pic = data
      }
      else {
        this.formData.upload_document[target].push(data)
        this[target] = this.formData.upload_document[target]
      }
    },
    handlerDeleteFile(otherData) {
      let { type, index,target } = otherData
      this.formData.upload_document[target].splice(index,1)
      this[target] = this.formData.upload_document[target]

    },
    handlerDeleteBrFiles({otherData}){
      let { type, index,target } = otherData
      // this.$set(this.formData, 'br_files_path_id', '')
      // this.$set(this.formData, 'br_files_type_pic_path', '')
      this.$set(this.formData.upload_document,type,[])
      this.br_files_type_pic = {}
    },
    network(){
      return{
      }
    },
  }
}
</script>
<style lang="scss" scoped>
/deep/.policy-form{
  width: 690px!important;
}
.policy-form{
   width: 690px!important;
   max-width: 690px;
  .box {
    padding-bottom: 15px;
    margin-bottom: 30px;
    border-bottom:1px solid #D1D5DA;;
    h3{
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #24292E;
    }
  }
  .travel-box{
    .flex{
      flex-wrap: wrap;
    }
  }
  .margin-top{
    margin-top: 10px;
  }
  .gray{
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #24292E;
    display: inline-block;
  }
}
/deep/ .max-content{
  width: max-content;
}
.select-time{
  .el-date-editor{
    width: 100%;
  }
}
</style>
